import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axios } from '@repo/http';
import { post_invite_people_path } from 'ze-api-contract/people-v2/post-create-invite';
import { orgPeopleList } from '../organization-people-list';
/** @deprecated Use ze-sdk equivalents. See docs/migration/DOMAIN_TO_SDK_MAPPING.md */ export function useInvitePeople() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (param)=>{
            let { organizationId, data } = param;
            return axios.post(post_invite_people_path({
                organization: organizationId
            }), data);
        },
        onSuccess: async (res, param)=>{
            let { organizationId } = param;
            await queryClient.invalidateQueries({
                queryKey: orgPeopleList.peopleList({
                    organization: organizationId
                }).queryKey
            });
        }
    });
}
